<template>
  <div class="lxm-contact-contact-remark">
    <div class="page">
      <transition name="lxm-content-transition" mode="out-in">
        <div v-if="!loading">
          <lxm-row v-for="row in rows"
                   :name="row.name">
            <template slot="content">
              {{ row.content }}
              <p class="lxm-contact-contact-remark__inscription has-text-right">
                ——
                <span class="lxm-contact-contact-remark__inscription-user">
                  {{ row.user }}
                </span>
                <span class="lxm-contact-contact-remark__inscription-update">
                  {{ row.update }}
                </span>
              </p>
            </template>
          </lxm-row>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="stylus">
  @import '../../../styles/variables.styl'
  .lxm-contact-contact-remark__inscription
    margin-top: spacing
  .lxm-contact-contact-remark__inscription-update
    margin-left: spacing
</style>

<script>
  import LxmRow from '../../common/LxmRow.vue'
  import * as aTypes from '../../../../store/action-types'
  import * as mTypes from '../../../../store/mutation-types'
  export default {
    components: {
      LxmRow
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      this.$store.dispatch(aTypes.CONTACT_GET_CONTACT_REMARKS, this.$route.query.contactId)
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_CONTACT_REMARKS]
      },
      state () {
        return this.$store.state.contact.remark
      },
      rows () {
        return this.state.list
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Remark.vue?051d31da